<div class="clientes container-fluid">
    <div class='row'>
        <div class='col-xl-4 col-sm-6' *ngFor="let cliente of clientes">
            <div class='card card-dark' style='min-height:255px'>
                <div class='card-header'>
                    <h2 class='card-title py-1 clientName d-flex align-items-start'>
                        <i class="fas p-1 text-sm"
                            [ngClass]="cliente.habilitado  ? 'fa-user-check text-success' : 'fa-user-times text-danger'"></i>
                        <span>{{cliente.nombre_completo}}</span>
                    </h2>
                    <div class='card-tools d-flex align-items-center'>
                        <app-edit-cliente [cliente]="cliente" (updateData)="updData()"></app-edit-cliente>
                    </div>
                </div>
                <div class='card-body'>
                    <input type='hidden' name='idCliente' [value]='cliente.id_cliente' />
                    <div class='row'>
                        <div class='col-12' *ngIf="cliente.email">
                            <span><i class='fas fa-envelope pr-2'></i>{{cliente.email}}</span>
                        </div>
                        <div class='col-12' *ngIf="cliente.telefono">
                            <span><i class='fas fa-phone pr-2'></i>{{cliente.telefono}}</span>
                        </div>
                        <div class='col-12' *ngIf="cliente.direccions[0]">
                            <span><i class='fas fa-map-marker-alt pr-2'></i>{{cliente.direccions[0].direccion}},
                                {{cliente.direccions[0].detalle != "" && cliente.direccions[0].detalle != null ? cliente.direccions[0].detalle + ", " : ""}}
                                {{cliente.direccions[0].comuna_nombre}}, {{cliente.direccions[0].provincia_nombre}}</span>
                        </div>
                    </div>
                </div>
                <div class='card-footer footer-user d-flex justify-content-between'>

                    <a class='btn btn-outline-secondary' *ngIf="cliente.email" href='mailto:{{cliente.email}}'
                        target='_blank'><i class='fas fa-envelope'></i></a>

                    <a class='btn btn-outline-info' *ngIf="cliente.telefono" href='tel:{{cliente.telefono}}'
                        target='_blank'><i class='fas fa-phone-volume'></i></a>
                    <a class='btn btn-outline-success' *ngIf="cliente.telefono" href='{{cliente.whatsapp}}'
                        target='_blank'><i class='fab fa-whatsapp'></i></a>

                    <a class='btn btn-outline-danger' *ngIf="cliente.direccions[0]"
                        href='https://www.google.cl/maps/place/{{cliente.direccions[0].direccion}},+{{cliente.direccions[0].comuna_nombre}},+{{cliente.direccions[0].provincia_nombre}},+{{cliente.direccions[0].region_nombre}}'
                        target='_blank'><i class='fas fa-map-marked-alt'></i></a>

                    <button type='button' (click)="goDetalleCliente(cliente.id_cliente)" name='seemore' class='btn btn-outline-dark'>
                        <i class='fas fa-ellipsis-h'></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>